"use strict"
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import './axios.js'
import './csrf.js'

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allow your team to quickly build robust real-time web applications.
 */

import './echo';

import "livewire-sortable";
import tippy, { followCursor } from "tippy.js";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";
import colorLib from "@kurkle/color";
import ui from "@alpinejs/ui";
import mask from "@alpinejs/mask";
import focus from "@alpinejs/focus";
import collapse from "@alpinejs/collapse";
import anchor from "@alpinejs/anchor";

window.tippy = tippy;
window.followCursor = followCursor;

document.addEventListener("alpine:init", () => {
    Alpine.plugin(ui, mask, focus, collapse, anchor);
    Alpine.data("colorLib", colorLib);
    // Magic: $tooltip
    Alpine.magic("tooltip", (el) => (message) => {
        let instance = tippy(el, { content: message, trigger: "manual" });
        instance.show();
        setTimeout(() => {
            instance.hide();
            setTimeout(() => instance.destroy(), 150);
        }, 2000);
    });

    // Directive: x-tooltip
    Alpine.directive("tooltip", (el, { expression, modifiers }) => {
        tippy(el, {
            content: expression,
            duration: [300, 400],
            delay: [50, 200],
            allowHTML: true,
            placement: modifiers[0] ?? "top",
            onShow(instance) {
                const prefersDarkScheme = window.matchMedia(
                    "(prefers-color-scheme: dark)",
                ).matches;
                const darkMode = localStorage.getItem("raid_theme") === "dark";

                instance.setProps({
                    theme:
                        prefersDarkScheme || darkMode ? "light" : "translucent",
                });
            },
            followCursor: "horizontal",
            plugins: [followCursor],
        });
    });
});
